var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#AEFCC6;}\r\n\t.st1{fill:none;stroke:#03B93F;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,23.7L12,23.7C5.5,23.7,0.3,18.5,0.3,12l0,0C0.3,5.5,5.5,0.3,12,0.3l0,0c6.5,0,11.7,5.2,11.7,11.7l0,0 C23.7,18.5,18.5,23.7,12,23.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.1,14.5c0.3-0.8,0.4-1.6,0.4-2.5c0-4.1-3.4-7.5-7.5-7.5C9.3,4.5,7,5.9,5.7,8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "5.5,4 5.5,8 9.5,8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.9,9.5c-0.3,0.8-0.4,1.6-0.4,2.5c0,4.1,3.4,7.5,7.5,7.5c2.7,0,5-1.4,6.3-3.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "18.5,20 18.5,16 14.5,16  "
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "12,7.5 12,12 15.5,12  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoreIcon);
export default __webpack_public_path__ + "static/media/restoreIcon.d3a7a5632265ca8bf1b9592dfc41ee15.svg";
export { ForwardRef as ReactComponent };